import profilePic from "../assets/profile-image.png";

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-white">
      {/* Decorative Background Glow */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 h-96 w-96 rounded-full bg-red-50 blur-3xl opacity-50"></div>

      <div className="relative mx-auto max-w-7xl px-4 py-20 sm:py-28 md:py-32">
        <div className="mx-auto max-w-3xl text-center">
          {/* Profile Image with Red Accent Ring */}
          <div className="relative mx-auto mb-8 h-28 w-28 sm:h-36 sm:w-36">
            <div className="absolute inset-0 rounded-full bg-red-600 animate-pulse opacity-20 scale-110"></div>
            <div className="relative h-full w-full rounded-full overflow-hidden border-4 border-white shadow-2xl ring-2 ring-red-100">
              <img
                src={profilePic}
                alt="Ruwan Indika"
                className="h-full w-full object-cover"
              />
            </div>
          </div>

          {/* Headline with AIA Red Gradient */}
          <h1 className="text-4xl font-extrabold tracking-tight sm:text-6xl md:text-7xl">
            <span className="bg-gradient-to-r from-red-600 to-red-800 bg-clip-text text-transparent">
              Ruwan Indika
            </span>
          </h1>

          {/* MDRT Badge / Designation Label */}
          <div className="mt-4 flex justify-center">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-red-50 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-red-700 ring-1 ring-inset ring-red-600/20">
              <svg
                className="h-1.5 w-1.5 fill-red-600"
                viewBox="0 0 6 6"
                aria-hidden="true"
              >
                <circle cx="3" cy="3" r="3" />
              </svg>
              MDRT Member | Wealth Planner
            </span>
          </div>

          <p className="mt-6 text-lg font-bold text-slate-900 sm:text-xl md:text-2xl uppercase tracking-tight">
            Your future deserves an expert guide
          </p>

          <p className="mt-6 text-base text-slate-600 sm:text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            As a dedicated AIA representative, I don’t just offer policies—I
            provide
            <span className="text-slate-900 font-semibold">
              {" "}
              peace of mind
            </span>{" "}
            through personalized protection plans built on real-world
            experience.
          </p>

          {/* Action Buttons */}
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <a
              href="#about"
              className="group relative flex items-center gap-2 rounded-full bg-red-600 px-8 py-4 text-base font-bold text-white shadow-lg shadow-red-200 transition-all hover:bg-red-700 hover:shadow-red-300 active:scale-95"
            >
              Learn My Story
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 transition-transform group-hover:translate-x-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </a>

            <a
              href="#contact"
              className="rounded-full border-2 border-slate-200 bg-white px-8 py-4 text-base font-bold text-slate-700 transition-all hover:bg-slate-50 hover:border-red-200 active:scale-95"
            >
              Contact Me
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex items-center justify-center gap-8 grayscale opacity-60">
            {/* You can add small AIA or MDRT logos here */}
            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">
              Trusted by families across Sri Lanka
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
